/**
 * A published LOINC code is a numeric block, a hyphen, and a single Mod-10
 * check digit — `3084-1`, `706-2`, `58709-7`. The hyphen is part of the code,
 * not a separator someone added.
 *
 * Used to tell a CODE query from a NAME query in the admin search, so a code
 * that isn't in the reference can be answered exactly ("no such code") rather
 * than with an empty result the curator has to interpret.
 *
 * Deliberately a SHAPE check, not a validity check: it does not verify the
 * check digit. `5950-0` is well-formed and absent from LOINC 2.83, and telling
 * those two states apart is the reference table's job, not a regex's.
 */
const LOINC_CODE_SHAPE = /^\d{1,7}-\d$/;
export function looksLikeLoincCode(value) {
    return LOINC_CODE_SHAPE.test(value.trim());
}
